// Internationalization data and helpers for web-chat
export var TRANSLATIONS = {
  fr: {
    chatTitle: 'Assistant IA',
    placeholder: 'Posez votre question ou décrivez votre besoin...',
    sendLabel: 'Envoyer',
    ariaLabel: 'Ouvrir le chat',
    tooltip: "Ouvrez l'assistant IA",
    micLabel: 'Dicter votre message',
    expandLabel: 'Agrandir le panneau',
    collapseLabel: 'Réduire le panneau',
    closeLabel: 'Fermer le panneau',
    initialBotMessage: 'Bonjour ! Comment puis-je vous aider aujourd’hui ?',
    initialUserMessage: 'Bonjour, je cherche de l’aide.',
    welcomeActions: {
      heading: 'Quelques exemples pour commencer',
      items: [
        { label: 'Rechercher une information', prompt: 'Dis moi quelle information rechercher', shortcut: '@radar', icon: 'search' },
        { label: 'Envoyer un email', prompt: 'Dis moi à qui veux tu envoyer cet email', shortcut: '@plume', icon: 'feather' },
        { label: 'Préparer un RDV', prompt: 'Dis moi quel RDV préparer', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    },
    tokenQuota: {
      exhaustedMessage: "Le quota de crédits de votre organisation est épuisé. La saisie sera réactivée dès qu'un solde sera disponible.",
      placeholder: 'Quota de crédits épuisé'
    },
    capabilityAutocomplete: {
      empty: 'Aucun agent correspondant'
    },
    capabilityBlockView: {
      confidenceHigh: 'élevée',
      confidenceMedium: 'moyenne',
      confidenceLow: 'faible',
      confidenceComputed: 'calculée',
      noRisk: 'Aucun risque identifié dans les données disponibles.',
      noOpportunity: 'Aucune opportunité spécifique identifiée dans les données disponibles.',
      noAction: 'Aucune action recommandée disponible.',
      noSummary: 'Résumé non disponible.',
      risks: 'Risques',
      risksAndOpportunities: 'Risques et opportunités',
      opportunities: 'Opportunités',
      levers: 'Leviers',
      recommendedActions: 'Actions recommandées',
      detailedSummary: 'Résumé détaillé',
      evidenceToggle: 'Voir les faits ayant conduit à l’analyse',
      keyPoints: 'Points clés',
      shortTimeline: 'Timeline courte',
      missingInformation: 'Informations manquantes',
      reliability: 'Fiabilité de la synthèse',
      executiveSummary: 'Résumé exécutif',
      deepen: 'Pour approfondir',
      showFullAnalysis: 'Afficher l’analyse complète',
      createAction: 'Créer'
    }
  },
  en: {
    chatTitle: 'AI Assistant',
    placeholder: 'Write a message...',
    sendLabel: 'Send',
    ariaLabel: 'Open chat',
    tooltip: 'Open the AI assistant',
    micLabel: 'Dictate your message',
    expandLabel: 'Expand panel',
    collapseLabel: 'Shrink panel',
    closeLabel: 'Close panel',
    initialBotMessage: 'Hello! How can I help you today?',
    initialUserMessage: 'Hello, I need some help.',
    welcomeActions: {
      heading: 'A few examples to get started',
      items: [
        { label: 'Search for information', prompt: 'Tell me what information to search for', shortcut: '@radar', icon: 'search' },
        { label: 'Send an email', prompt: 'Tell me who you want to email', shortcut: '@plume', icon: 'feather' },
        { label: 'Prepare a meeting', prompt: 'Tell me which meeting to prepare', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    },
    tokenQuota: {
      exhaustedMessage: "Your organization's credit quota is exhausted. Input will be re-enabled as soon as balance is available.",
      placeholder: 'Credit quota exhausted'
    },
    capabilityAutocomplete: {
      empty: 'No matching agent'
    },
    capabilityBlockView: {
      confidenceHigh: 'high',
      confidenceMedium: 'medium',
      confidenceLow: 'low',
      confidenceComputed: 'computed',
      noRisk: 'No risk identified in the available data.',
      noOpportunity: 'No specific opportunity identified in the available data.',
      noAction: 'No recommended action available.',
      noSummary: 'Summary unavailable.',
      risks: 'Risks',
      risksAndOpportunities: 'Risks and opportunities',
      opportunities: 'Opportunities',
      levers: 'Levers',
      recommendedActions: 'Recommended actions',
      detailedSummary: 'Detailed summary',
      evidenceToggle: 'View the facts behind the analysis',
      keyPoints: 'Key points',
      shortTimeline: 'Short timeline',
      missingInformation: 'Missing information',
      reliability: 'Summary reliability',
      executiveSummary: 'Executive summary',
      deepen: 'Explore further',
      showFullAnalysis: 'Show full analysis',
      createAction: 'Create'
    }
  },
  es: {
    chatTitle: 'Asistente IA',
    placeholder: 'Escribe un mensaje...',
    sendLabel: 'Enviar',
    ariaLabel: 'Abrir chat',
    tooltip: 'Abre el asistente IA',
    micLabel: 'Dictar tu mensaje',
    expandLabel: 'Ampliar panel',
    collapseLabel: 'Reducir panel',
    closeLabel: 'Cerrar panel',
    initialBotMessage: '¡Hola! ¿En qué puedo ayudarte hoy?',
    initialUserMessage: 'Hola, necesito ayuda.',
    welcomeActions: {
      heading: 'Algunos ejemplos para empezar',
      items: [
        { label: 'Buscar información', prompt: 'Dime qué información buscar', shortcut: '@radar', icon: 'search' },
        { label: 'Enviar un correo', prompt: 'Dime a quién quieres enviar este correo', shortcut: '@plume', icon: 'feather' },
        { label: 'Preparar una reunión', prompt: 'Dime qué reunión preparar', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    }
  },
  it: {
    chatTitle: "Assistente IA",
    placeholder: 'Scrivi un messaggio...',
    sendLabel: 'Invia',
    ariaLabel: 'Apri chat',
    tooltip: "Apri l'assistente IA",
    micLabel: 'Detta il tuo messaggio',
    expandLabel: 'Espandi pannello',
    collapseLabel: 'Riduci pannello',
    closeLabel: 'Chiudi pannello',
    initialBotMessage: 'Ciao! Come posso aiutarti oggi?',
    initialUserMessage: 'Ciao, ho bisogno di aiuto.',
    welcomeActions: {
      heading: 'Alcuni esempi per iniziare',
      items: [
        { label: 'Cercare informazioni', prompt: 'Dimmi quale informazione cercare', shortcut: '@radar', icon: 'search' },
        { label: 'Inviare un’email', prompt: 'Dimmi a chi vuoi inviare questa email', shortcut: '@plume', icon: 'feather' },
        { label: 'Preparare un appuntamento', prompt: 'Dimmi quale appuntamento preparare', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    }
  },
  pl: {
    chatTitle: 'Asystent AI',
    placeholder: 'Napisz wiadomość...',
    sendLabel: 'Wyślij',
    ariaLabel: 'Otwórz czat',
    tooltip: 'Otwórz asystenta AI',
    micLabel: 'Dyktafon wiadomości',
    expandLabel: 'Powiększ panel',
    collapseLabel: 'Zmniejsz panel',
    closeLabel: 'Zamknij panel',
    initialBotMessage: 'Cześć! W czym mogę dziś pomóc?',
    initialUserMessage: 'Cześć, potrzebuję pomocy.',
    welcomeActions: {
      heading: 'Kilka przykładów na początek',
      items: [
        { label: 'Wyszukaj informację', prompt: 'Powiedz, jakiej informacji szukać', shortcut: '@radar', icon: 'search' },
        { label: 'Wyślij e-mail', prompt: 'Powiedz, do kogo wysłać ten e-mail', shortcut: '@plume', icon: 'feather' },
        { label: 'Przygotuj spotkanie', prompt: 'Powiedz, które spotkanie przygotować', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    }
  },
  de: {
    chatTitle: 'KI-Assistent',
    placeholder: 'Schreibe eine Nachricht...',
    sendLabel: 'Senden',
    ariaLabel: 'Chat öffnen',
    tooltip: 'Öffne den KI-Assistenten',
    micLabel: 'Diktiere deine Nachricht',
    expandLabel: 'Panel erweitern',
    collapseLabel: 'Panel verkleinern',
    closeLabel: 'Panel schließen',
    initialBotMessage: 'Hallo! Wie kann ich Ihnen heute helfen?',
    initialUserMessage: 'Hallo, ich brauche Hilfe.',
    welcomeActions: {
      heading: 'Einige Beispiele für den Anfang',
      items: [
        { label: 'Informationen suchen', prompt: 'Sagen Sie mir, welche Information ich suchen soll', shortcut: '@radar', icon: 'search' },
        { label: 'E-Mail senden', prompt: 'Sagen Sie mir, an wen Sie diese E-Mail senden möchten', shortcut: '@plume', icon: 'feather' },
        { label: 'Meeting vorbereiten', prompt: 'Sagen Sie mir, welches Meeting ich vorbereiten soll', shortcut: '@briefing', icon: 'calendarCheck' }
      ]
    }
  }
}

export function localeKey(lang) {
  if (!lang) return 'fr'
  var k = String(lang).toLowerCase()
  return k.slice(0, 2)
}

export var SPEECH_MAP = {
  en: 'en-US',
  es: 'es-ES',
  it: 'it-IT',
  pl: 'pl-PL',
  de: 'de-DE',
  fr: 'fr-FR'
}
